var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.117188 14C0.117188 6.26801 6.3852 0 14.1172 0C21.8492 0 28.1172 6.26801 28.1172 14C28.1172 21.732 21.8492 28 14.1172 28C6.3852 28 0.117188 21.732 0.117188 14Z",
    fill: "#F6F8FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1172 15.75C16.0502 15.75 17.6172 14.183 17.6172 12.25C17.6172 10.317 16.0502 8.75 14.1172 8.75C12.1842 8.75 10.6172 10.317 10.6172 12.25C10.6172 14.183 12.1842 15.75 14.1172 15.75Z",
    stroke: "#4566EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86719 18.8125C9.92648 16.9821 11.8504 15.75 14.1172 15.75C16.384 15.75 18.3079 16.9821 19.3672 18.8125",
    stroke: "#4566EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOutline);
export default __webpack_public_path__ + "static/media/person-outline.c797f3c0a478079669595e969f579f3a.svg";
export { ForwardRef as ReactComponent };